var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full mb-2"},[_c('BaseButton',{attrs:{"block":"","outlined":!_vm.isPrimary,"icon":_vm.activeProvider.icon,"icon-variant":"brand","icon-position":"before","class-prop":(_vm.isPrimary
        ? _vm.classes.primaryButtonClasses
        : _vm.classes.secondaryButtonClasses) || ''},on:{"click":_vm.triggerLogin}},[_vm._v(" "+_vm._s(_vm.$t(_vm.activeProvider.actionTitle))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }